module.exports = __webpack_public_path__ + "img/PLGS.46fbc3ae.png";